import { addMonths, startOfDay } from 'date-fns';
import { SearchFilterType } from '../../../components/TableFilters/types';
import { FilterType, FutureInvoicesReportSortColumnId, RequiresApproval } from './types';
export const futureInvoicesReportTextsPath = 'futureInvoicesReport';
export const futureInvoicesColumnHeadersTextsPath = 'futureInvoicesReport.columnHeaders';
export const futureInvoicesDateValidationTextsPath = 'futureInvoicesReport.dateValidation';
export const futureInvoicesCsvHeadersTextsPath = 'futureInvoicesReport.csvHeaders';
export function getHeaderItems(texts) {
    return [
        {
            value: texts.companyName(),
            sortId: FutureInvoicesReportSortColumnId.CompanyName
        },
        {
            value: texts.issueDate(),
            sortId: FutureInvoicesReportSortColumnId.IssueDate
        },
        {
            value: texts.dueDate(),
            sortId: FutureInvoicesReportSortColumnId.DueDate
        },
        {
            value: texts.requiresApproval(),
            sortId: FutureInvoicesReportSortColumnId.RequiresApproval
        },
        {
            value: texts.total(),
            sortId: FutureInvoicesReportSortColumnId.Total
        },
        {
            value: ''
        }
    ];
}
export const futureInvoicesReportColumnDefs = [
    {
        width: [
            300,
            330
        ],
        sortable: true,
        bi: {
            name: 'sort_future_invoices_by_company_name'
        }
    },
    {
        width: [
            120,
            150
        ],
        sortable: true,
        bi: {
            name: 'sort_future_invoices_by_issue_date'
        }
    },
    {
        width: [
            120,
            150
        ],
        sortable: true,
        bi: {
            name: 'sort_future_invoices_by_due_date'
        }
    },
    {
        width: [
            130,
            160
        ],
        sortable: true,
        bi: {
            name: 'sort_future_invoices_by_requires_approval'
        }
    },
    {
        width: [
            160,
            300
        ],
        sortable: true,
        bi: {
            name: 'sort_future_invoices_by_total'
        }
    },
    {
        width: [
            140,
            170
        ],
        sortable: false,
        hAlign: 'end'
    }
];
export const makeFilterConfig = (param)=>{
    let { filtersOptions, now, texts } = param;
    const today = startOfDay(now);
    const dateLimits = {
        min: today,
        max: addMonths(today, 12),
        minDateMessage: texts.minDateMessage(),
        maxDateMessage: texts.maxDateMessage()
    };
    const initialDate = {
        from: now,
        to: addMonths(now, 1)
    };
    return {
        [FilterType.CompanyName]: {
            type: SearchFilterType.MultiSelectFilter,
            options: filtersOptions[FilterType.CompanyName] || [],
            withSearchbox: true,
            removable: true
        },
        [FilterType.AgreementName]: {
            type: SearchFilterType.MultiSelectFilter,
            options: filtersOptions[FilterType.AgreementName] || [],
            withSearchbox: true,
            removable: true
        },
        [FilterType.IssueDate]: {
            type: SearchFilterType.DateRangeFilter,
            dateLimits,
            initialDate,
            removable: true
        },
        [FilterType.DueDate]: {
            type: SearchFilterType.DateRangeFilter,
            dateLimits,
            initialDate,
            removable: true
        },
        [FilterType.RequiresApproval]: {
            type: SearchFilterType.MultiSelectFilter,
            options: Object.values(RequiresApproval),
            removable: true
        }
    };
};
export const makeCsv = (param)=>{
    let { futureInvoices, texts } = param;
    const headersToExport = [
        texts.columnHeaders.companyName(),
        texts.csvHeaders.agreementName(),
        texts.columnHeaders.issueDate(),
        texts.columnHeaders.dueDate(),
        texts.columnHeaders.requiresApproval(),
        texts.columnHeaders.total()
    ];
    return [
        headersToExport
    ].concat(futureInvoices.map((futureInvoice)=>[
            futureInvoice.companyName(),
            futureInvoice.agreementName(),
            futureInvoice.issueDate(),
            futureInvoice.dueDate(),
            futureInvoice.requiresApproval() ? RequiresApproval.Yes : RequiresApproval.No,
            futureInvoice.rawTotal().toString()
        ]));
};
export const getDefaultSort = (sortIds)=>({
        colIndex: sortIds.indexOf(FutureInvoicesReportSortColumnId.IssueDate),
        sort: 'asc'
    });
